import { useState } from 'react';
import { t } from 'i18next';
import Modal, { ModalBody, ModalFooter } from '../modal/modal';
import { usePushNotification } from '../../scripts/hooks/usePushNotification';

export function PushMergePrompt() {
  const { shouldPromptMerge, mergeSubscription, dismissMergePrompt } = usePushNotification();
  const [isOpen, setIsOpen] = useState(true);
  const [isMerging, setIsMerging] = useState(false);

  if (!shouldPromptMerge || !isOpen) {
    return null;
  }

  const handleAccept = async () => {
    setIsMerging(true);
    try {
      await mergeSubscription();
      dismissMergePrompt();
      setIsOpen(false);
    } catch {
      setIsMerging(false);
    }
  };

  const handleDismiss = () => {
    dismissMergePrompt();
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen
      onRequestClose={handleDismiss}
      title={t('settings:push-notifications.merge-prompt.title')}
      centered
    >
      <ModalBody>
        <p className="slds-text-body--regular">
          {t('settings:push-notifications.merge-prompt.message')}
        </p>
      </ModalBody>
      <ModalFooter>
        <button className="slds-button slds-button--neutral slds-m-right--small" onClick={handleDismiss}>
          {t('settings:push-notifications.merge-prompt.dismiss')}
        </button>
        <button className="slds-button slds-button--brand" onClick={handleAccept} disabled={isMerging}>
          {isMerging ? (
            <>
              <i className="fa fa-spinner fa-spin slds-m-right--x-small" />
              {t('settings:push-notifications.merge-prompt.linking')}
            </>
          ) : (
            <>
              <i className="fa fa-link slds-m-right--x-small" />
              {t('settings:push-notifications.merge-prompt.accept')}
            </>
          )}
        </button>
      </ModalFooter>
    </Modal>
  );
}
